
import React from 'react'
import CardContenedor from '../components/CardContenedor'
import { Volver } from '../components/Volver'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import FormularioVacaciones from './FormularioVacaciones';
import ListadoVacaciones from './ListadoVacaciones';
import useListadoVacaciones from '../hooks/useListadoVacaciones';
import { Toaster } from 'react-hot-toast';


export default function SolicitarVacaciones() {

	const { traerDatos } = useListadoVacaciones()


	return (
		<CardContenedor>
			<Volver />


			<Tabs
				defaultActiveKey="formulario"
				id="uncontrolled-tab-example"
				className="mb-3"
				unmountOnExit={true}
				fill
				onSelect={ ( a ) => {
					if ( a === 'listado' ) {
						traerDatos()
					}
				} }
			>
				<Tab eventKey="formulario" title="Solicitar vacaciones" className='m-3'>
					<FormularioVacaciones/>
				</Tab>
				<Tab eventKey="listado" title="Listado de solicitudes" className='m-3'>
					<ListadoVacaciones/>
				</Tab>
			</Tabs>

			<Toaster/>

		</CardContenedor>
	)
}

